__turbopack_context__.v({
  "content": "List-module-scss-module__A-Dkdq__content",
  "counter": "List-module-scss-module__A-Dkdq__counter",
  "list": "List-module-scss-module__A-Dkdq__list",
});
